// extracted by mini-css-extract-plugin
export default {"-large":"ubu56pmAuJrulVvVEsj5","teamInviteUpsellingCard":"vopjINQCON1vCBllHK_A"};